import {
  Avatar,
  Grid,
  Skeleton,
  Typography,
} from '@silverstein-properties/inspirelabs-ui';
import { MainContainerGrid } from '../../MessagesModule.styles';
import {
  SideMessagesMainGrid,
  SideMessagesTitleGrid,
} from '../SideMessages/SideMessages.styles';
import { StyledSideMessageCardGrid } from '../SideMessageCard/SideMessageCard.styles';
import { MainMessagesTitleGrid } from '../MainMessages/MainMessages.styles';
import { Stack } from '@mui/material';

const SIDE_MESSAGE_CARD_COUNT = 10;
const MAIN_MESSAGE_CARD_COUNT = 3;

const SideMessageCardSkeleton = () => {
  return (
    <StyledSideMessageCardGrid
      container
      item
      isSelected={false}
      sx={{ cursor: 'default' }}
    >
      <Grid item container xs={12} sx={{ paddingY: 2 }}>
        <Grid item>
          <Skeleton variant="rounded" width={104}>
            <Typography>Text</Typography>
          </Skeleton>
        </Grid>
        <Grid container item xs={12} justifyContent="space-between">
          <Grid item>
            <Skeleton width={120}>
              <Typography>Text</Typography>
            </Skeleton>
          </Grid>
          <Grid item>
            <Skeleton width={48}>
              <Typography>Text</Typography>
            </Skeleton>
          </Grid>
        </Grid>
        <Grid container item xs={12} width="100%">
          <Skeleton width="100%">
            <Typography>Text</Typography>
          </Skeleton>
        </Grid>
        <Grid container item xs={12} width="100%">
          <Skeleton width="100%">
            <Typography>Text</Typography>
          </Skeleton>
        </Grid>
      </Grid>
    </StyledSideMessageCardGrid>
  );
};

const MainMessageCardSkeleton = () => {
  return (
    <Grid
      container
      item
      sx={{ alignItems: 'center', ':not(:last-child)': { pb: 4 } }}
      xs={12}
    >
      <Grid container item mt={2}>
        <Stack alignItems="center" flexDirection="row" columnGap={1}>
          <Skeleton variant="circular">
            <Avatar />
          </Skeleton>
          <Skeleton variant="rounded">
            <Typography variant="subtitle2">Some Name</Typography>
          </Skeleton>
          <Skeleton variant="rounded">
            <Typography variant="subtitle2">Random</Typography>
          </Skeleton>
        </Stack>
      </Grid>
      <Grid item xs sx={{ ml: 6 }} width="100%">
        <Skeleton variant="rounded" width={80}>
          <Typography variant="body2">Text</Typography>
        </Skeleton>
        <Skeleton variant="rounded" width={300} sx={{ mt: 1 }}>
          <Typography variant="body2">Text</Typography>
        </Skeleton>
        <Skeleton variant="rounded" width="100%" height={100} sx={{ mt: 1 }} />
        <Skeleton variant="rounded" width={60} sx={{ mt: 1 }}>
          <Typography variant="body2">Text</Typography>
        </Skeleton>
      </Grid>
    </Grid>
  );
};

export const MessagesSkeleton = () => {
  return (
    <MainContainerGrid container>
      <SideMessagesMainGrid container item xs={4} alignContent="flex-start">
        <SideMessagesTitleGrid container item columnGap={1}>
          <Skeleton variant="rounded">
            <Typography variant="h4">Messages</Typography>
          </Skeleton>
          <Skeleton variant="circular">
            <Avatar />
          </Skeleton>
        </SideMessagesTitleGrid>
        <Grid
          container
          item
          xs={12}
          sx={{
            // 100vh is 100% of the screen height, subtract 128px for the
            // container padding, 64px is for the header of the messages,
            // 88px is for the navbar and 2px is for borders
            height: 'calc(100vh - 128px - 64px - 88px - 2px)',
            overflow: 'auto',
            alignContent: 'flex-start',
          }}
        >
          {[...Array(SIDE_MESSAGE_CARD_COUNT)].map((_, i) => (
            <SideMessageCardSkeleton key={`sideMessage_skeleton_${i}`} />
          ))}
        </Grid>
      </SideMessagesMainGrid>
      <Grid container item xs={8} alignContent="flex-start">
        <MainMessagesTitleGrid item xs={12}>
          <Skeleton variant="rounded">
            <Typography variant="h6">Main Message</Typography>
          </Skeleton>
          <Skeleton variant="rounded" sx={{ mt: 0.5 }} width={400}>
            <Typography variant="body2">Details</Typography>
          </Skeleton>
        </MainMessagesTitleGrid>
        <Grid
          container
          item
          xs={12}
          sx={{
            pt: 1,
            // 100vh is 100% of the screen height, subtract 128px for the
            // container padding, 64px is for the header of the messages,
            // 88px is for the navbar and 2px is for borders
            height: 'calc(100vh - 128px - 88px - 64px - 2px - 96px)',
            overflow: 'auto',
            alignContent: 'flex-start',
            borderBottom: ({ palette }) => `1px solid ${palette.grey[400]}`,
          }}
        >
          <Grid
            container
            item
            xs={12}
            sx={{
              alignItems: 'center',
              paddingX: 5,
              paddingY: 2,
              justifyContent: 'center',
            }}
          >
            <Skeleton variant="rounded">
              <Typography color="primary.medium" variant="subtitle2">
                {/* Random date to take the exact space */}
                June 5, 2025
              </Typography>
            </Skeleton>
            {[...Array(MAIN_MESSAGE_CARD_COUNT)].map((_, i) => (
              <MainMessageCardSkeleton key={`mainMessage_skeleton_${i}`} />
            ))}
          </Grid>
        </Grid>
        <Grid
          container
          item
          sx={{ margin: theme => theme.spacing(3, 5), width: '100%' }}
        >
          <Grid item xs={12}>
            <Skeleton variant="rounded" width="100%" height={52} />
          </Grid>
        </Grid>
      </Grid>
    </MainContainerGrid>
  );
};
